import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddPurchaseChannel = () => {
    const [formData, setFormData] = useState({
        pack_unit: '',
        pack_qty: '',
        unit: '',
        quantity: '',
        free_quantity: '',
        rate: '',
        amount: '',
        mrp: '',
        net_rate: '',
        remark: '',
        item_barcode: '',
        bd_batch_no: '',
        bd_mfg_date: '',
        bd_exp_date: '',
        bd_sale_rate: '',
        item_balance: '',
        barcode: '',
        line_level_barcode: '',
        hsn_code: '',
        brand: ''
    });

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Handle form input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Submit form data to the API
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        fetch(`${BASE_URL}purchasechannels`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    alert('Purchase channel added successfully');
                    navigate('/PurchaseChannelsList'); // Redirect to the list after successful submission
                } else {
                    alert('Error adding purchase channel');
                }
            })
            .catch((error) => {
                alert('Error submitting data');
                console.error('Error:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Purchase Channel</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Purchase Channel Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="pack_unit" className="form-label">Pack Unit</label>
                                                <input
                                                    type="text"
                                                    id="pack_unit"
                                                    name="pack_unit"
                                                    className="form-control"
                                                    value={formData.pack_unit}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="pack_qty" className="form-label">Pack Quantity</label>
                                                <input
                                                    type="number"
                                                    id="pack_qty"
                                                    name="pack_qty"
                                                    className="form-control"
                                                    value={formData.pack_qty}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="unit" className="form-label">Unit</label>
                                                <input
                                                    type="text"
                                                    id="unit"
                                                    name="unit"
                                                    className="form-control"
                                                    value={formData.unit}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="quantity" className="form-label">Quantity</label>
                                                <input
                                                    type="number"
                                                    id="quantity"
                                                    name="quantity"
                                                    className="form-control"
                                                    value={formData.quantity}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="free_quantity" className="form-label">Free Quantity</label>
                                                <input
                                                    type="number"
                                                    id="free_quantity"
                                                    name="free_quantity"
                                                    className="form-control"
                                                    value={formData.free_quantity}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="rate" className="form-label">Rate</label>
                                                <input
                                                    type="number"
                                                    id="rate"
                                                    name="rate"
                                                    className="form-control"
                                                    value={formData.rate}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="amount" className="form-label">Amount</label>
                                                <input
                                                    type="number"
                                                    id="amount"
                                                    name="amount"
                                                    className="form-control"
                                                    value={formData.amount}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="mrp" className="form-label">MRP</label>
                                                <input
                                                    type="number"
                                                    id="mrp"
                                                    name="mrp"
                                                    className="form-control"
                                                    value={formData.mrp}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="net_rate" className="form-label">Net Rate</label>
                                                <input
                                                    type="number"
                                                    id="net_rate"
                                                    name="net_rate"
                                                    className="form-control"
                                                    value={formData.net_rate}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="remark" className="form-label">Remark</label>
                                                <textarea
                                                    id="remark"
                                                    name="remark"
                                                    className="form-control"
                                                    value={formData.remark}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="item_barcode" className="form-label">Item Barcode</label>
                                                <input
                                                    type="text"
                                                    id="item_barcode"
                                                    name="item_barcode"
                                                    className="form-control"
                                                    value={formData.item_barcode}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="bd_batch_no" className="form-label">Batch No</label>
                                                <input
                                                    type="text"
                                                    id="bd_batch_no"
                                                    name="bd_batch_no"
                                                    className="form-control"
                                                    value={formData.bd_batch_no}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="bd_mfg_date" className="form-label">Manufacturing Date</label>
                                                <input
                                                    type="date"
                                                    id="bd_mfg_date"
                                                    name="bd_mfg_date"
                                                    className="form-control"
                                                    value={formData.bd_mfg_date}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="bd_exp_date" className="form-label">Expiry Date</label>
                                                <input
                                                    type="date"
                                                    id="bd_exp_date"
                                                    name="bd_exp_date"
                                                    className="form-control"
                                                    value={formData.bd_exp_date}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="bd_sale_rate" className="form-label">Sale Rate</label>
                                                <input
                                                    type="number"
                                                    id="bd_sale_rate"
                                                    name="bd_sale_rate"
                                                    className="form-control"
                                                    value={formData.bd_sale_rate}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="item_balance" className="form-label">Item Balance</label>
                                                <input
                                                    type="number"
                                                    id="item_balance"
                                                    name="item_balance"
                                                    className="form-control"
                                                    value={formData.item_balance}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="barcode" className="form-label">Barcode</label>
                                                <input
                                                    type="text"
                                                    id="barcode"
                                                    name="barcode"
                                                    className="form-control"
                                                    value={formData.barcode}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="line_level_barcode" className="form-label">Line Level Barcode</label>
                                                <input
                                                    type="text"
                                                    id="line_level_barcode"
                                                    name="line_level_barcode"
                                                    className="form-control"
                                                    value={formData.line_level_barcode}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="hsn_code" className="form-label">HSN Code</label>
                                                <input
                                                    type="text"
                                                    id="hsn_code"
                                                    name="hsn_code"
                                                    className="form-control"
                                                    value={formData.hsn_code}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="brand" className="form-label">Brand</label>
                                                <input
                                                    type="text"
                                                    id="brand"
                                                    name="brand"
                                                    className="form-control"
                                                    value={formData.brand}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Adding...' : 'Add Purchase Channel'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddPurchaseChannel;
